// Wolf override (MOB-2 tamable + neutral, M13.1). PURE (ENG-1).
//
// Layers two behaviours on the tamable base:
//   • owner-assist — a TAMED wolf attacks whatever its owner most recently struck
//     (EntitySystem.assistTargetId), the classic wolf-pack defence;
//   • pack anger  — a WILD wolf that gets hit turns hostile and bites the player
//     for the anger window (neutral mob).
import type { MobDef } from '../../registry/schemas';
import type { Entity, MobContext } from '../entity';
import { tamable } from '../archetypes/tamable';
import { meleeAI } from '../archetypes/melee';
import { meleeEntity } from '../archetypes/shared';

export function wolf(e: Entity, def: MobDef, ctx: MobContext): void {
  // Tamed & standing: defend the owner against their current assist target.
  if (e.tamed && !e.sitting) {
    const assist = ctx.sys.byId(ctx.sys.assistTargetId);
    if (assist && assist.id !== e.id && !assist.tamed) e.targetEntityId = assist.id;
    const target = ctx.sys.byId(e.targetEntityId);
    if (target && !target.tamed) { meleeEntity(e, def, ctx, target); return; }
    e.targetEntityId = -1;
  }
  // Wild & provoked: chase and bite the nearest player while anger lasts.
  if (!e.tamed && e.angerTimer > 0 && meleeAI(e, def, ctx)) return;

  tamable(e, def, ctx);
}
